export const DeviceWidth = {
  mobile: 500,
  tablet: 768,
  laptop: 1024,
  laptopLarge: 1200,
  desktop: 1400,
  fullHd: 1918,
  xl: 2560,
};

export const Device = {
  mobile: `@media (max-width: ${DeviceWidth.mobile}px)`,
  tablet: `@media (max-width: ${DeviceWidth.tablet}px)`,
  laptop: `@media (max-width: ${DeviceWidth.laptop}px)`,
  laptopLarge: `@media (max-width: ${DeviceWidth.laptopLarge}px)`,
  desktop: `@media (max-width: ${DeviceWidth.desktop}px)`,
  fullHd: `@media (max-width: ${DeviceWidth.fullHd}px)`,
  fullHdDown: `@media (max-width: ${DeviceWidth.fullHd - 1}px)`,
  fullHdUp: `@media (min-width: ${DeviceWidth.fullHd + 1}px)`,
  xl: `@media (max-width: ${DeviceWidth.xl}px)`,
};
